import { useNavigate } from 'react-router-dom';
import { contentActionsService } from '../../../utils/ContentActionsService/ContentActionsService';
import { useEventSource } from '../../../utils/LocationContext';
import { useIsMobile } from '../../../utils/getIsMobile';
import { openExternalLink } from '../../../utils/openExternalLink';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { LEARN_MORE_URL } from './constants';

export const CpaTrialDialog = () => {
    const navigate = useNavigate();
    const t = useTranslation();
    const isMobile = useIsMobile();
    const { eventSource } = useEventSource();

    const handleClose = () => {
        navigate(-1);
    };

    const handleLearnMore = () => {
        if (eventSource) {
            contentActionsService.trackRewardDetailsClick({
                screen: eventSource,
            });
        }
        openExternalLink(LEARN_MORE_URL);
    };

    const titleContent = (
        <Typography variant="title2" weight="bold">
            {t('Вознаграждение')}
        </Typography>
    );

    const mainContent = (
        <Flex direction="column" spacing={4}>
            <Flex direction="column" spacing={1.5}>
                <Typography variant="body">
                    {t(
                        'Ваши публикации помогают бизнесам продвигать товары, и за это вы можете получить вознаграждение. Когда сумма достигнет 1000 ₽, вы сможете подать заявление на договор, а мы проверим его и сообщим результат.',
                    )}
                </Typography>

                <Typography variant="body">
                    {t('Обратите внимание: вывод доступен только самозанятым, ИП и юрлицам.')}
                </Typography>
            </Flex>

            <Flex width="100%" direction={isMobile ? 'column' : 'row'} spacing={1}>
                <Button
                    color="secondary"
                    variant="filled"
                    size="l"
                    onClick={handleLearnMore}
                    width="100%"
                    style={{ letterSpacing: '0.7px' }}
                >
                    {t('Подробнее')}
                </Button>
            </Flex>
        </Flex>
    );

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={titleContent}
            mainContent={mainContent}
            forceCloseButton={true}
            hideTrigger={true}
        />
    );
};
